import dayjs from 'dayjs';
import { DATEFORMAT_SHORT_ISO } from '@ps20-frontend/utils';
import { StatePreV13, StateV13 } from './13_migrate_warenkorb_vorteilsrabatt.interface';

export const migrateWarenkorbVorteilsrabatte = (
  previousState: StatePreV13,
  newVersion: number,
  currentState: StateV13,
): StateV13 => {
  const today = dayjs().format(DATEFORMAT_SHORT_ISO);
  const isFtVorteilsRabatt = currentState.transientState.featureToggles['VORTEILSRABATT'];
  let oldRabattExist = false;
  const migratedWarenkorb = previousState.warenkorb.map(angebot => {
    const result = {
      ...angebot,
      angebotsdatum: angebot.beibehalten ? '1900-01-01' : angebot.angebotsdatum || today,
    };
    if (angebot.rbd > 0 || angebot.treuebonus > 0) {
      oldRabattExist = true;
    }
    if (isFtVorteilsRabatt && !angebot.beibehalten) {
      result.rbd = 0;
      result.treuebonus = 0;
    }

    return result;
  });

  return {
    ...previousState,
    version: newVersion,
    warenkorb: migratedWarenkorb,
    transientState: {
      ...currentState.transientState,
      showVorteilsRabattHinweis: isFtVorteilsRabatt && oldRabattExist,
    },
  };
};
